module.exports = __webpack_public_path__ + "img/add.2c1c25b1.svg";